import { Injectable } from '@angular/core';
import { ITreeOptions } from 'angular-tree-component';

export interface MyTreeOptions extends ITreeOptions {}
